import { Flex, Layout } from "@draftkings/arena-web";
import * as React from "react";
import { TeamDetails } from "../../TeamDetails";
import { Reference } from "../../Reference";
import { SportsbookContext } from "../../../contexts";
export const FixtureEventCard = React.memo(function FixtureEventCard(props) {
    const notLiveEventRefferences = props.shortLabel ? [props.shortLabel, props.formattedStartEventDate] : [props.formattedStartEventDate];
    const references = props.isLive ? [props.shortLabel] : notLiveEventRefferences;
    const { getIcon } = React.useContext(SportsbookContext);
    return React.createElement(Layout, { variant: "eventCard", testId: 'event-card' },
        React.createElement(Flex, null,
            React.createElement(TeamDetails, Object.assign({}, props))),
        React.createElement(Flex, { gap: "5px", marginTop: "5px" },
            props.isLive && getIcon("live"),
            React.createElement(Reference, { id: props.eventId, references: references, testId: "event-reference" })));
});
//# sourceMappingURL=FixtureEventCard.js.map